<template>
<drawer :opened.sync="opened" @close="onCloseBtnClick" style="min-width: 85%;">
  <template #header>{{name}}相关性分析</template>

  <template #body>
    <data-wrapper>
      <!-- <template #header>
        <unit-switch
          :default-unit-prop.sync="unitProp"
          @change="onUnitPropChange"
        />
      </template> -->

      <trend-related-chart-wrapper
        :data-list="data"
        :unit-prop="unitProp"
        :download-name="downloadName"
        :factors="filterFactors"
        :scale="true"
        show-list
      />
    </data-wrapper>
  </template>

  <template #footer>
    <a class="cancel-btn btn" @click="onCloseBtnClick">关闭</a>
  </template>
</drawer>
</template>

<script>
import BaseSiteFactorData from '../../../BaseSiteFactorData'
import TrendRelatedChartWrapper from '../../../../components/Data/TrendRelatedChartWrapper'

export default {
  name: 'Editor',
  extends: BaseSiteFactorData,
  components: {TrendRelatedChartWrapper},
  data () {
    return {
      opened: false,
      data: [],
      name: ''
    }
  },
  computed: {
    downloadName () {
      return this.name + '对比'
    }
  },
  methods: {
    open (model) {
      this.data = Object.freeze(model.data)
      this.name = model.name
      this.opened = true
    },
    onCloseBtnClick () {
      this.close()
    },
    close () {
      this.opened = false
      this.$emit('close')
    },
    getSeriesParam (dimension, dimensionIds) {
      return {
        type: 'line',
        showSymbol: false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
h1 {
  font-size: 17px;
  margin: 8px 0;
}
p {
  margin: 5px 0;
  display: flex;

  span {
    display: inline-block;
    width: 50%;
    text-align: left;
    display: flex;
    align-items: center;

    section {
      width: 15px;
      height: 15px;
    }
  }

  :nth-child(2) {
    margin-left: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/06Data-Management/02Normal/13AQIRelatedAnalysis/Editor.vue